import React, { useEffect, useState } from "react";
import { useGerenciamento } from "../../Context/GerenciamentoContext";

import { gridConfigMap } from "../../Config/gridConfigMap";
import { serviceMap } from "../../Config/serviceMap";
import { formsMap } from "../../Config/formsMap";

import Grid from "../Grid/Grid";
import FormContainer from "../FormContainer/FormContainer";

import DashboardPage from "../Dashboard/DashboardPage";

export default function ConteudoDinamico() {
  const { modulo, acao, itemSelecionado, selecionarAcao } = useGerenciamento();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const chaveModulo = modulo?.value ?? modulo;
  const gridConfig = gridConfigMap[chaveModulo];

  useEffect(() => {
    async function carregarDados() {
      if (!chaveModulo || acao !== "pesquisar" || chaveModulo === "dashboard") return;

      const service = serviceMap[chaveModulo];
      if (!service || !gridConfig) {
        setData([]);
        return;
      }

      const metodo = gridConfig.serviceMethod || "getAll";
      if (typeof service[metodo] !== "function") {
        console.error(`Método ${metodo} não existe no service de ${chaveModulo}`);
        setData([]);
        return;
      }

      setLoading(true);
      try {
        const response = await service[metodo]();
        setData(response || []);
      } catch (error) {
        console.error("Erro ao carregar dados da grid:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    }

    carregarDados();
  }, [chaveModulo, acao, gridConfig]);


  if (chaveModulo === "dashboard") {
    return <DashboardPage />;
  }

  if (!modulo || !gridConfig) return null;

  const grid = (
    <Grid
      columns={gridConfig.columns || []}
      data={data}
      idField={gridConfig.idField || "id"}
      loading={loading}
    />
  );

  if (acao === "novo" || acao === "alterar") {
    const FormSelecionado = formsMap[chaveModulo];
    if (!FormSelecionado) return grid;

    return (
      <>
        {grid}
        <FormContainer onClose={() => selecionarAcao("pesquisar")}>
          <FormSelecionado
            modo={acao}
            itemSelecionado={itemSelecionado}
            onClose={() => selecionarAcao("pesquisar")}
          />
        </FormContainer>
      </>
    );
  }

  return grid;
}
